export const MEDIA = 'dd/MEDIA';
export const HISTORY_ENTRY = 'dd/HISTORY_ENTRY';
export const WAITLIST_USER = 'dd/WAITLIST_USER';
